import { render, staticRenderFns } from "./TransferKbkAddModal.vue?vue&type=template&id=01024ba0&scoped=true&"
import script from "./TransferKbkAddModal.vue?vue&type=script&lang=ts&"
export * from "./TransferKbkAddModal.vue?vue&type=script&lang=ts&"
import style0 from "./TransferKbkAddModal.vue?vue&type=style&index=0&id=01024ba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01024ba0",
  null
  
)

export default component.exports